export const appNavigationNavClassName = "app-navigation";
export const appNavigationLinkClassName = `${appNavigationNavClassName}__link`;
export const appNavigationLinkActiveClassName = `${appNavigationLinkClassName}--active`;
